<script>
import HeroHeader from '@/components/HeroHeader.vue'
import FormCard from '@/components/FormCard.vue'

export default {
  components: { HeroHeader, FormCard },

  computed: {
    protocolo() { return this.$route.params.protocol || 'AXEN-000000' },
  },

  methods: {
    novoCadastro() { this.$router.push({ name: 'wizard' }) },
    copiarProtocolo() {
      const t = this.protocolo
      if (navigator.clipboard) {
        navigator.clipboard.writeText(t).then(
          () => this.$toast.success('Protocolo copiado.'),
          () => {}
        )
      }
    },
  },
}
</script>

<template>
  <div class="page">
    <HeroHeader
      title="Cadastro recebido!"
      subtitle="Já estamos cuidando do resto."
    />

    <main class="container-narrow wizard-shell">
      <FormCard>
        <div class="success">
          <div class="success__check" aria-hidden="true">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="11" fill="#15803D"/>
              <path d="M7 12.5l3.5 3.5L17 9" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>

          <h2 class="success__title">Recebemos o seu cadastro</h2>
          <p class="success__text">
          Nossa equipe vai analisar suas informações e documentos e, caso houver alguma inconsistência, entrará em contato pelo e-mail ou WhatsApp que você informou. Guarde o seu número de protocolo:
          </p>

          <button type="button" class="success__protocol" @click="copiarProtocolo" :title="'Clique para copiar'">
            {{ protocolo }}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="9" y="9" width="13" height="13" rx="2"/>
              <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/>
            </svg>
          </button>

          <div class="success__steps">
            <h3>O que acontece agora?</h3>
            <div class="steps-list">
              <div class="step-card">
                <span class="step-card__num">1</span>
                <p class="step-card__text"><strong>Em alguns instantes você receberá os documentos de adesão ao Clube Solar da AXEN por e-mail. Abra este e-mail, inicie e conclua o processo de assinatura, que é totalmente digital;</strong></p>
              </div>
              <div class="step-card">
                <span class="step-card__num">2</span>
                <p class="step-card__text">Após assinatura, nossa equipe receberá esses documentos para validação;</p>
              </div>
              <div class="step-card">
                <span class="step-card__num">3</span>
                <p class="step-card__text">Estando tudo ok com a documentação, ela será enviada para a sua Concessionária realizar a vinculação da sua unidade consumidora na Usina que vai gerar os créditos de energia em sua fatura;</p>
              </div>
              <div class="step-card">
                <span class="step-card__num">4</span>
                <p class="step-card__text">Em breve você começará a economizar todos os meses com a AXEN Clube Solar.</p>
              </div>
            </div>
          </div>

          <button type="button" class="btn btn--ghost" @click="novoCadastro">
            Cadastrar outra instalação
          </button>
        </div>
      </FormCard>
    </main>

    <footer class="footer">
      © {{ new Date().getFullYear() }} Axen Energia
    </footer>
  </div>
</template>

<style scoped lang="scss">
@import "~@/design/success";
</style>
